module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_3016.6529cf07.png";